import { render, staticRenderFns } from "./AppListPickup.vue?vue&type=template&id=766a9ea1&"
import script from "./AppListPickup.vue?vue&type=script&lang=ts&"
export * from "./AppListPickup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports